module.exports = __webpack_public_path__ + "img/im.661f5dae.svg";